export default function findParents(tree, childData) {
  //
  // The .atn property here is an "ascendancy number," as documented here:
  // https://www.familysearch.org/developers/docs/api/tree/Ancestry_resource
  //
  // Based on the Ahnentafel system: https://en.wikipedia.org/wiki/Ahnentafel
  // Your family tree is numbered like this:
  //                you (1)
  //               /       \
  //              /         \
  //         dad (2)        mom (3)
  //        /      |        |      \
  // gdad (4)  gmom (5)  gdad (6)  gmom (7)

  // father
  const parent1 = tree.find((person) => person.atn === childData.atn * 2)
  // mother
  const parent2 = tree.find((person) => person.atn === childData.atn * 2 + 1)

  if (!parent1 && !parent2) {
    return {}
  }

  return { parent1, parent2 }
}
